import {
  AutocompleteInput,
  ReferenceInput,
  required,
  SelectInput,
} from "react-admin";
import MuiDatePickerInput from "../../common/MuiDatePickerInput";

const filterToQuery = (searchText) => ({ all: searchText });

const accountReceivableAgingFilterList = (permissions) => {
  const customerCodeFilter = { code_options: true };
  const defaultFilter = [
    <MuiDatePickerInput
      alwaysOn
      source="start_date"
      variant="outlined"
      label="mine.label.start_date"
      maxDateSource="end_date"
    />,
    <MuiDatePickerInput
      alwaysOn
      source="end_date"
      variant="outlined"
      label="mine.label.end_date"
      minDateSource="start_date"
    />,
    <MuiDatePickerInput
      alwaysOn
      source="cut_off"
      variant="outlined"
      label="mine.label.cut_off_date"
    />,
    <ReferenceInput
      alwaysOn
      source="start_customer_id"
      reference="customers"
      filter={customerCodeFilter}
      sort={{ field: "customers.code", order: "ASC" }}
      perPage={25}
    >
      <AutocompleteInput
        resettable
        optionText="code"
        filterToQuery={filterToQuery}
        variant="outlined"
        label="mine.label.start_code"
      />
    </ReferenceInput>,
    <ReferenceInput
      alwaysOn
      source="end_customer_id"
      reference="customers"
      filter={customerCodeFilter}
      sort={{ field: "customers.code", order: "ASC" }}
      perPage={25}
    >
      <AutocompleteInput
        resettable
        optionText="code"
        filterToQuery={filterToQuery}
        variant="outlined"
        label="mine.label.end_code"
      />
    </ReferenceInput>,
    <SelectInput
      alwaysOn
      source="kind"
      variant="outlined"
      label="mine.label.kind"
      validate={required()}
      choices={[
        { id: "per_surat_jalan", name: "Per Surat Jalan" },
        { id: "per_jatuh_tempo", name: "Per Jatuh Tempo" },
        { id: "per_salesman", name: "Per Salesman" },
        { id: "per_jenis", name: "Per Jenis" },
        { id: "per_supplier", name: "Per Supplier" },
      ]}
    />,
  ];
  if (permissions && permissions.update_company) {
    defaultFilter.unshift(
      // defaultFilter.splice(
      // 1,
      // 0,
      <ReferenceInput
        alwaysOn
        source="company_id"
        reference="companies"
        sort={{ field: "companies.alias", order: "ASC" }}
      >
        <AutocompleteInput
          resettable
          optionText="alias"
          variant="outlined"
          label="mine.label.company"
        />
      </ReferenceInput>
    );
  }
  return defaultFilter;
};

export default accountReceivableAgingFilterList;
